import { render, staticRenderFns } from "./TermsOfUse.html?vue&type=template&id=85614a66&scoped=true&"
import script from "./TermsOfUse.js?vue&type=script&lang=js&"
export * from "./TermsOfUse.js?vue&type=script&lang=js&"
import style0 from "./TermsOfUse.scss?vue&type=style&index=0&id=85614a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85614a66",
  null
  
)

export default component.exports